
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { DecimalPipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
  ViewContainerRef,
  EventEmitter,
  Output,
  SimpleChanges,
  Renderer2,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { Sort, MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { ContactSalesComponent } from 'src/app/common/components/contact-sales/contact-sales.component';

import { GlobalContants } from 'src/app/common/constants/global.contants';
import { SharedService } from 'src/app/common/services/shared.service';
import { UserService } from 'src/app/common/services/user.service';
import { ReportMapService } from 'src/app/reports/services/report-map.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { Subject } from 'rxjs';
import { CommonPropertyDetailConstant } from '../common-property-detail-page.constant';
import { CommonPropertyDetailPageService } from '../common-property-detail-page.service';

@Component({
  selector: 'app-property-detail-land-parcels',
  templateUrl: './property-detail-land-parcels.component.html',
  styleUrls: ['./property-detail-land-parcels.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class PropertyDetailLandParcelsComponent {
  @Input() property_uid: string = '';
  @Input() parcel_uid: string = '';
  
  @ViewChild(MatSort) matSort!: MatSort;
  @Output() isEmpatyCheck = new EventEmitter();
  @ViewChild(MatPaginator) matPaginator: MatPaginator | any;
  tableColumns: any[] = CommonPropertyDetailConstant.landParcelColumns;
  tableData: any[] = [];
  dataLength: number = 0;
  downloadLoading: boolean = false;
  allowExcelDownload: boolean = false;
  startIndex: number = 1;
  limit: number = 20;
  offset: number = 0;
  sortOrder: string = '';
  expandedElement: any = [];
  current_lang: string = 'en';
  CurrencyCode: string = '';
  languageSub$: Subscription = new Subscription();
  selectedIndex: string | null = null;
  expandbgColor = '';
  LockReport: boolean = true;
  totalPages: number | any;
  maxIndexValue: number = 20;
  endIndex: number = 20;
  goToPageNumber: number = 1;
  previousPageNbr: number = 1;
  allowDownload: boolean = false;
  currentReportData: any = null;
  placeCode: any;
  reportId!: number;

  loading = false;

  private destroy$ = new Subject<void>();

  constructor(
    private sharedService: SharedService,
    private translate: TranslateService,
    private mapService: ReportMapService,
    private reportService: ReportService,
    private propertyService: CommonPropertyDetailPageService,
    private alertService: AlertService,
    private _decimalPipe: DecimalPipe,
    private cdr: ChangeDetectorRef,
    private elementRef: ViewContainerRef,
    private ren: Renderer2,
    private matdailog: MatDialog,
    private userService: UserService,
    private activatedRoute: ActivatedRoute
  ) {
    this.languageSub$ = this.sharedService.language$.subscribe((lang) => {
      setTimeout(() => (this.current_lang = lang));
      this.CurrencyCode = this.translate.instant(
        this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode)
      );
      this.placeCode = this.sharedService.getStoreValue(
        GlobalContants.StoreKey.placeCode
      );
      if (this.property_uid) {
        this.fetchTableData();
      }
    });
  }

  ngOnInit(): void {
    this.currentReportData = this.reportService.getCurrentReport();
    this.CurrencyCode = this.translate.instant(
      this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode)
    );
    this.placeCode = this.sharedService.getStoreValue(
      GlobalContants.StoreKey.placeCode
    );
    this.reportId = this.activatedRoute.snapshot.queryParams['rid'];
    // this.fetchTableData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['property_uid']?.currentValue || changes['parcel_uid']?.currentValue) {
      this.fetchTableData();
    }
    this.LockReport = this.reportService.getLockReport();

  }

  ngAfterViewInit(): void {
    if (this.matSort) this.matSort.disableClear = true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.languageSub$.unsubscribe();
  }

  fetchTableData() {
    this.loading=true;
    this.propertyService
      .getPropertyLandParcel(this.property_uid, this.sortOrder, this.limit, this.offset, this.parcel_uid)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          if (res.status === 200 && res.data) {
            this.tableData = res.data.map((item: any) => ({
                           ...item,
                           matched: !!(item?.parcel_uid == this.parcel_uid)
                         }));

            this.tableData = this.reportService.setTableDataSource(this.tableData);
            if (this.offset == 0) {
              this.dataLength = res.count;
            }
            
            this.setTableDataSource(this.tableData);
            this.isEmpatyCheck.emit(false);
            this.startIndex = this.offset + 1;
            this.endIndex = Math.min(this.offset + this.limit, this.dataLength);
          } else {
            this.tableData = [];
            this.dataLength = 0;
            this.isEmpatyCheck.emit(true);
          }
        },
        error: () => {
          this.loading = false;
          this.tableData = [];
          this.dataLength = 0;
          this.isEmpatyCheck.emit(true);
        }
      });
  }

  isChildOpen(ele: any, pIndex: number) {
    const currentExpand = ele.expand;
    for (let j = 0; j < this.tableData.length; j++) {
      if (this.tableData[j].isParent) {
        this.tableData[j].expand = false;
      }
    }
    ele.expand = !currentExpand;
    this.onParentClick(pIndex);
    this.tableData = [...this.tableData];
  }

  onParentClick(parentIndex: number): void {
    if (this.tableData[parentIndex].isParent) {
      const isCurrentlyOpen = this.tableData[parentIndex].expand;
      for (let j = 0; j < this.tableData.length; j++) {
        if (!this.tableData[j].isParent) {
          this.tableData[j].isOpen = 1;
        }
      }
      let i = parentIndex + 1;
      while (i < this.tableData.length && !this.tableData[i].isParent) {
        this.tableData[i].isOpen = isCurrentlyOpen ? 2 : 1;
        i++;
      }
    }
  }

  showLayout(value: any, is_unit_layout?: boolean) {
    if (is_unit_layout) value['is_unit_layout'] = true;
    this.mapService.propertyinfotoggle.next(true);
    this.mapService.selected_propertydetails.next(value);
    this.reportService.showTenantMap$.next(value);
  }


  isCharNumber(value: any) {
    const toolTipValue =
      typeof value === 'string'
        ? value
        : this._decimalPipe.transform(value, '1.0-1');
    return `${toolTipValue} ${this.translate.instant(
      this.CurrencyCode
    )}/${this.translate.instant(
      GlobalContants.keySymbolContants.squareMeterUnit
    )}`;
  }

  setExpadndColor(index: number) {
    this.expandbgColor = '#EBF1FF';
  }

  setTableDataSource(data: any): void {
    this.LockReport = this.reportService.getLockReport();
    if (this.LockReport) {
      data = data.slice(0, 3);
      for (let i = 0; i < 3; i++) {
        let temp: any = {};
        this.tableColumns.map((e: any) => {
          temp[e.field] = e.convertNumber ? 1111111 : 'No data';
          temp['NODATA'] = true;
        });
        data.push(temp);
      }
      this.tableData = data;
    } else {
      this.tableData = data;
    }
    this.cdr.detectChanges();
    if (this.matPaginator) {
      this.totalPages = this.matPaginator.getNumberOfPages();
      this.addGoToPageInput();
    }
  }

  addGoToPageInput() {
    const actionContainer = this.elementRef.element.nativeElement.querySelector('div.mat-mdc-paginator-range-actions');
    const nextButtonDefault = this.elementRef.element.nativeElement.querySelector('button.mat-mdc-paginator-navigation-next');
    let bubbleContainerRef: any = this.ren.createElement('div') as HTMLElement;
    this.ren.addClass(bubbleContainerRef, 'g-bubble-container');
    this.ren.insertBefore(actionContainer, bubbleContainerRef, nextButtonDefault);
    bubbleContainerRef.appendChild(this.elementRef.element.nativeElement.querySelector('.go-to-page'));
  }

  openContactSales() {
    this.matdailog.open(ContactSalesComponent, {
      width: '600px',
      maxHeight: '95vh',
      panelClass: 'contact-form',
      data: { Type: 'contact_us' },
    });
  }

  onPageChange(event: PageEvent) {
    this.limit = event.pageSize;
    this.offset = event.pageIndex * event.pageSize;
    this.startIndex = this.offset + 1;
    this.endIndex = Math.min(this.offset + this.limit, this.dataLength);

    this.fetchTableData();
    this.goToPageNumber = event.pageIndex + 1;
  }

  onGoToPage() {
    if (this.goToPageNumber > this.totalPages || this.goToPageNumber <= 0) {
      this.goToPageNumber = this.previousPageNbr;
      return;
    }
    this.previousPageNbr = this.goToPageNumber;
    this.matPaginator.pageIndex = this.goToPageNumber - 1;
    const event: PageEvent = {
      length: this.matPaginator.length,
      pageIndex: this.matPaginator.pageIndex,
      pageSize: this.matPaginator.pageSize,
    };
    this.goToPageNumber = (event.pageIndex || 0) + 1;
    this.onPageChange(event);
  }
  onSortTable(event: Sort) {
    let activeheader = event.active;
    this.sortOrder = event.direction
      ? JSON.stringify({ column: activeheader, order: event.direction }).replace(/[+]/g, '%2B')
      : '';
    this.offset = 0;
    this.goToPageNumber = 1;
    if (this.matPaginator) this.matPaginator.pageIndex = 0;
    this.fetchTableData();
  }

  resetPageIndex() {
    if (this.matPaginator) {
      this.matPaginator.pageIndex = 0;
    }
  }
}
